import React from 'react';
import { XMarkIcon } from './icons';

interface CommercialTransactionActProps {
  isOpen: boolean;
  onClose: () => void;
}

export const CommercialTransactionAct: React.FC<CommercialTransactionActProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
        {/* ヘッダー */}
        <div className="flex items-center justify-between p-6 border-b">
          <h2 className="text-xl font-bold text-slate-900">特定商取引法に基づく表記</h2>
          <button
            onClick={onClose}
            className="text-slate-400 hover:text-slate-600"
          >
            <XMarkIcon className="w-6 h-6" />
          </button>
        </div>

        {/* コンテンツ */}
        <div className="p-6 max-h-[70vh] overflow-y-auto">
          <div className="prose prose-slate max-w-none">
            <div className="text-slate-700 leading-relaxed space-y-6">
              
              <section>
                <h3 className="text-lg font-semibold text-slate-900 mb-2">販売事業者</h3>
                <p>プロフィールスタジオ／株式会社オレンジアーク</p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-slate-900 mb-2">運営責任者</h3>
                <p>福島伸幸</p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-slate-900 mb-2">所在地</h3>
                <p>〒231-0063 神奈川県横浜市中区花咲町2-78</p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-slate-900 mb-2">お問い合わせ先</h3>
                <p>メール：<a href="mailto:support@profile-studio.online" className="text-blue-600 hover:underline">support@profile-studio.online</a></p>
                <p className="text-sm text-slate-600 mt-2">
                  営業時間：平日10:00–18:00（原則2営業日以内に返信）
                </p>
                <p className="text-sm text-slate-500 mt-1">
                  ※お電話でのサポートは行っておりません。電話番号はご請求いただいた場合、遅滞なく開示いたします。
                </p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-slate-900 mb-2">サイトURL</h3>
                <p><a href="https://profile-studio.online" className="text-blue-600 hover:underline">https://profile-studio.online</a></p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-slate-900 mb-3">販売価格・提供内容</h3>
                <p className="mb-3">価格はいずれも <strong>税込</strong> 表示です。</p>
                <p className="mb-3">デジタルサービス（画像生成クレジット）の販売・提供を行います。</p>
                
                <div className="overflow-x-auto">
                  <table className="min-w-full border border-slate-300 text-sm">
                    <thead className="bg-slate-100">
                      <tr>
                        <th className="border border-slate-300 px-4 py-2 text-left">プラン</th>
                        <th className="border border-slate-300 px-4 py-2 text-left">価格</th>
                        <th className="border border-slate-300 px-4 py-2 text-left">内容</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="border border-slate-300 px-4 py-2">Standard</td>
                        <td className="border border-slate-300 px-4 py-2">¥500</td>
                        <td className="border border-slate-300 px-4 py-2">10枚（買い切り）</td>
                      </tr>
                      <tr>
                        <td className="border border-slate-300 px-4 py-2">Pro</td>
                        <td className="border border-slate-300 px-4 py-2">¥1,000</td>
                        <td className="border border-slate-300 px-4 py-2">25枚（買い切り）</td>
                      </tr>
                      <tr>
                        <td className="border border-slate-300 px-4 py-2">Pro Max</td>
                        <td className="border border-slate-300 px-4 py-2">¥5,000/月</td>
                        <td className="border border-slate-300 px-4 py-2">月200枚（自動更新）</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                
                <p className="text-sm text-slate-600 mt-3">
                  販売数量の上限：特に上限は設けていません（不正・迷惑行為が疑われる場合はご注文をお断りすることがあります）。
                </p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-slate-900 mb-2">商品代金以外の必要料金</h3>
                <ul className="list-disc pl-5 space-y-1">
                  <li>インターネット接続に係る通信費等はお客様のご負担となります。</li>
                  <li>送料は発生しません（デジタル提供のため）。</li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-slate-900 mb-2">代金の支払方法・時期</h3>
                <p className="mb-2"><strong>支払方法：</strong>クレジットカード（Visa / Mastercard / American Express 等）</p>
                <p className="mb-2"><strong>支払時期：</strong></p>
                <ul className="list-disc pl-5 space-y-1">
                  <li>買い切りプラン：申込時に即時決済</li>
                  <li>月額プラン（Pro Max）：初回申込時に決済、以降毎月自動で更新（請求日は申込日基準）</li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-slate-900 mb-2">引き渡し（役務提供）の時期</h3>
                <ul className="list-disc pl-5 space-y-1">
                  <li>決済完了後、即時にクレジットを付与します。</li>
                  <li>月額プランは各請求サイクルの開始時に月200枚へリセットされます。</li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-slate-900 mb-2">返品・交換・キャンセルについて</h3>
                <ul className="list-disc pl-5 space-y-1">
                  <li>デジタル商品の性質上、決済完了後のキャンセル・返金はお受けできません。</li>
                  <li>二重課金など当社起因の不具合が確認できた場合は、重複分の返金または同等クレジットの付与で対応します。</li>
                  <li>法令上のクーリング・オフは、通信販売には適用されません。</li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-slate-900 mb-2">定期課金（サブスクリプション）の解約</h3>
                <ul className="list-disc pl-5 space-y-1">
                  <li>マイページ「プラン管理」からいつでも解約できます。</li>
                  <li>解約の申請後も、次回請求日までは利用可能です。日割り返金はありません。</li>
                  <li>次回請求日の直前は処理に時間を要することがあるため、少なくとも前日までの手続きをお願いします。</li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-slate-900 mb-2">動作環境</h3>
                <ul className="list-disc pl-5 space-y-1">
                  <li>最新版のWebブラウザ（Chrome / Safari / Edge など）</li>
                  <li>画像アップロード形式：JPEG / PNG、最大10MBまで推奨</li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-slate-900 mb-2">表現および再現性に関する注意</h3>
                <ul className="list-disc pl-5 space-y-1">
                  <li>生成結果は入力画像・利用環境により変動します。表現どおりの結果を保証するものではありません。</li>
                  <li>アップロード画像は利用規約・法令に違反しないものに限ります。</li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-slate-900 mb-2">特別条件</h3>
                <ul className="list-disc pl-5 space-y-1">
                  <li>未成年者が購入・契約する場合は、親権者の同意を得たうえでお申し込みください。</li>
                  <li>不正利用が判明した場合、アカウント停止等の措置を講じることがあります。</li>
                </ul>
              </section>

              <div className="mt-8 pt-6 border-t border-slate-200">
                <p className="text-sm text-slate-500">
                  最終更新日: 2025年10月9日
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* フッター */}
        <div className="border-t p-4 bg-slate-50 text-center">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
          >
            閉じる
          </button>
        </div>
      </div>
    </div>
  );
};

